import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { CompanyTelefon } from './company-telefon';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-company-telefon-update',
  templateUrl: './company-telefon-update.component.html'
})
export class CompanyTelefonUpdateComponent extends BaseUpdateComponent<CompanyTelefon> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }
  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Broj", Validators.required, 'required', 'FIRMATELEFON.BROJ.VALIDATION.REQUIRED');
    this.addValidatorToFc("Broj", Validators.maxLength(20), 'maxlength', 'FIRMATELEFON.BROJ.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Lokal", Validators.maxLength(4), 'maxlength', 'FIRMATELEFON.LOKAL.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Opis", Validators.maxLength(100), 'maxlength', 'FIRMATELEFON.OPIS.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SvojinaID", Validators.required, 'required', 'FIRMATELEFON.SVOJINA.VALIDATION.REQUIRED');
    this.addValidatorToFc("VrstaTelefonaID", Validators.required, 'required', 'FIRMATELEFON.VRSTATELEFONA.VALIDATION.REQUIRED');
  }

}
